import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { formatAmount } from '@dxb-web-ui-framework/common/utils/Math';
import { Box, makeStyles, Theme } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { SkeletonTypography } from '../../../../../content-composer/src/components/Generic/Skeleton';

const useStyles = makeStyles<Theme>(({ palette }) => ({
  successText: {
    color: palette.success.main,
  },
}));

export type SuccessInfoProps = {
  amount?: number;
  currency?: string;
  numberFormat: string;
  t: TFunction;
  isLoading: boolean;
  isTransactionSettled: boolean;
  transactionId?: string;
};

const SuccessInfo: FC<SuccessInfoProps> = ({
  amount,
  currency,
  numberFormat,
  t,
  isLoading,
  isTransactionSettled,
  transactionId,
}) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const classes = useStyles();

  return (
    <>
      <SkeletonTypography
        hasSkeleton={isLoading}
        typographyProps={{ variant: isMobile ? 'h3' : 'h2', component: 'h1', className: classes.successText }}>
        {t('fundsTransfer.SuccessStep.label')}
      </SkeletonTypography>
      <Box mt={2} mb={1}>
        <SkeletonTypography hasSkeleton={isLoading} typographyProps={{ variant: 'h5', color: 'secondary' }}>
          {amount && currency ? formatAmount(amount, currency, 2, numberFormat) : '-'}
        </SkeletonTypography>
      </Box>
      <SkeletonTypography hasSkeleton={isLoading} typographyProps={{ color: 'textSecondary' }}>
        {isTransactionSettled
          ? t('fundsTransfer.SuccessStep.subtitle', {
              transactionId: transactionId ?? '',
            })
          : t('fundsTransferPage.TransferFlow.StatusNotSettled', {
              transactionId: transactionId ?? '',
            })}
      </SkeletonTypography>
    </>
  );
};

export { SuccessInfo };
